module.exports = __webpack_public_path__ + "img/map_1791458178255_21800.37bd0003.jpg";